import { PurchaseOrderEnums } from "src/app/enum/purchase-order-enum";

export class PurchaseOrderModel {
  purchaseOrderId: number = 0;
  branchId: number = 0;
  consecutive: number = 0;
  alterNumber: number | null = null;
  datePurchaseOrder: Date = new Date;
  enterpriseId: number = 0;
  providerId: number = 0;
  address: string = "";
  wayToPay: number = PurchaseOrderEnums.wayToPayCredit;
  referenceDocument: string | null = null;
  purchaseOrderState: number = PurchaseOrderEnums.stateOpen;
  annulDate: Date | null = null;
  observation: string | null = null;
  subtotalValue: number = 0;
  ivaValue: number = 0;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
